import { put,getContext} from "redux-saga/effects";
import importer from "common/importer";
const { getRedeemPaused } = importer("GraphQL/Queries");
const PublicContentActions = importer('Stores/PublicContent/Actions')

export default function* main() {
  try {
    yield put(PublicContentActions.getRedeemPausedLoading());
    const apolloClient = yield getContext('client')
    const query = getRedeemPaused;
    const { data, error } = yield apolloClient.query({
      query,
      variables: {},
    });
    if (error) {
      throw error;
    }
    const res = data?.salesforce_loyaltyprogram[0];
    
    yield put(
      PublicContentActions.getRedeemPausedSuccess(res)
    );
  } catch (error) {
    yield put(PublicContentActions.getRedeemPausedFailure(error));
  }
}
